<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <page-header title="Sistema" subTitle="Configurações" />

    <d-row>
      <d-col md="12">
        <d-card>
          <d-tabs card ref="tabs">
            <d-tab title="Dados da empresa" active class="p-3" v-if="isAdmin || hasSettingsModule">
              <company-form/>
            </d-tab>
            <d-tab title="Variáveis do sistema" class="p-3" v-if="isAdmin || hasSettingsModule">
              <settings-form/>
            </d-tab>
            <d-tab title="Controle de acesso" class="p-3" v-if="isAdmin || hasAccessControlModule">
              <access-control-form/>
            </d-tab>
          </d-tabs>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import CompanyForm from '_modules/settings/components/CompanyForm.vue';
import SettingsForm from '_modules/settings/components/SettingsForm.vue';
import AccessControlForm from '_modules/settings/components/AccessControlForm.vue';
import {
  _LOAD_MODEL_COMPANY_,
  _LOAD_MODEL_SETTING_,
  COMPANY,
  SETTINGS,
} from '../components/SettingsModel';

export default {
  name: 'setting-profile',
  components: {
    PageHeader,
    CompanyForm,
    SettingsForm,
    AccessControlForm,
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    hasAccessControlModule() {
      const { user } = this.$store.state.user;
      if (user && user.modules.some(item => item.slug === 'access-control')) {
        return true;
      }
      return false;
    },
    hasSettingsModule() {
      const { user } = this.$store.state.user;
      if (user && user.modules.some(item => item.slug === 'settings')) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getSettings',
      'checkAdmin',
    ]),
    company() {
      const { company } = this.$store.state.settings;
      if (company) {
        Events.$emit(_LOAD_MODEL_COMPANY_, company);
        return company;
      }
      return COMPANY;
    },
    getSettingsSystem() {
      this.setToggle({ type: 'progress', bool: true });
      this.getSettings()
        .then(() => {
          this.loadSettings();
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    loadSettings() {
      this.company();
      this.settings();
    },
    settings() {
      const { settings } = this.$store.state.settings;
      if (settings) {
        Events.$emit(_LOAD_MODEL_SETTING_, settings);
        return settings;
      }
      return SETTINGS;
    },
  },
  mounted() {
    if (this.hasSettingsModule) {
      this.getSettingsSystem();
    }
  },
};
</script>

<style lang="scss">
.tabs {
  .card-header { background: rgba(0, 0, 0, 0.03); }
}
</style>
